import { render, staticRenderFns } from "./DomiciliosCliente.vue?vue&type=template&id=0d07cf4a&scoped=true"
import script from "./DomiciliosCliente.vue?vue&type=script&lang=js"
export * from "./DomiciliosCliente.vue?vue&type=script&lang=js"
import style0 from "./DomiciliosCliente.vue?vue&type=style&index=0&id=0d07cf4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07cf4a",
  null
  
)

export default component.exports